export class ListValue {
    public Name: string;
    public Value: number;

     constructor(name:string, value: number) {
        this.Name = name;
        this.Value = value;
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/list/list-value.model.ts